import { PropsWithChildren, createContext, useState } from "react";
import { getHasuraClaimsFromToken, getStoredIdToken } from "../authToken";
import { isPageAccessControlledRole, withPersonalPageKeys } from "../constants/pageAccess";

const idToken = getStoredIdToken();
const claims = idToken ? getHasuraClaimsFromToken(idToken) : null;
const jwtDefaultRole: string = claims?.["x-hasura-default-role"] || "";
const jwtAllowedRoles: string[] = claims?.["x-hasura-allowed-roles"] || [];
const localRole = localStorage.getItem("x-hasura-user-role");
const role =
  localRole ||
  jwtDefaultRole ||
  jwtAllowedRoles?.[0] ||
  "";
const persistedRolePageAccess = localStorage.getItem("qa-role-page-access");
let parsedRolePageAccess: string[] = [];
try {
  parsedRolePageAccess = persistedRolePageAccess ? JSON.parse(persistedRolePageAccess) : [];
} catch (_error) {
  parsedRolePageAccess = [];
}

export const initialState = {
  profile: {
    id:"",
    firstName: "",
    lastName: "",
    mailId: "",
    phonenumber: "",
    photo: "",
    profileUpdate: false,
    deviceToken: '',
    userRole:role||"",
    allowedPageKeys: Array.isArray(parsedRolePageAccess)
      ? withPersonalPageKeys(parsedRolePageAccess)
      : [],
    pageAccessLoaded: isPageAccessControlledRole(role) && persistedRolePageAccess !== null ? true : false
  },
  globalSearch:{
    searchtext: "",
    affiliateUsersClicked:false,
    searchcancel:false
  },
  userUpdate:{
    updated:false
  },
  ticketUpdate:{
    updatedticket : false,
    delistTicket : false,
    listPrice : false,
    returnTicket:false,
    listTicket: false
  },
  publishticket:{
    publish : false
  },
  notification:{
    notificationClicked:false,
    text:"",
    ticketId:null,
    tpId:null,
    tp_id_array:null,
    newNotification: "",
    notificationSearchCancel:false,
    reSettingNotificationCount:false,
    lastAlertedFeedMs: 0,
  },
  error: {
    text : "",
    errorClicked: false,
    approximateTpArray : null,
    ticketPlacementId : null,
    errorSearchCancel:false,
    userError : false,
    status : ""
  },
  manageTicketFilter: {
    leagueId: null,
    leagueName: '',
    validstatus: null,
    startdate: null,
    enddate: null,
    periodLeft: null,
    selectedDateValue: '',
    isCustomRange: false,
    startDateRange: null,
    endDateRange: null,
    isFilter: false,
    currentdate:"",
    notificationFilterDataCount:0,
    errorFilterDataCount:0,
    clicked: false
  },
  listTicketFilter: {
    leagueId: null,
    leagueName: '',
    isFilter: false,
    ticketStatus: null,
    startdate: null,
    enddate: null,
    startDateRange: null,
    endDateRange: null,
    selectedDateValue: '',
    isCustomRange: false,
    notificationFilterDataCount:0,
    errorFilterDataCount:0,
    clicked: false
  },
  newListTicketsFilter: {
    leagueId: [],
    ticketStatus: [],
    isFilter: false,
    startdate: null,
    enddate: null,
    startDateRange: null,
    endDateRange: null,
    selectedDateValue: '',
    isCustomRange: false,
    clicked: false
  },
  newSoldTicketsFilter: {
    leagueId: [],
    ticketStatus: [],
    isFilter: false,
    startdate: null,
    enddate: null,
    startDateRange: null,
    endDateRange: null,
    selectedDateValue: '',
    isCustomRange: false,
    clicked: false
  },
  newDelistedTicketsFilter: {
    leagueId: [],
    ticketStatus: [],
    isFilter: false,
    startdate: null,
    enddate: null,
    startDateRange: null,
    endDateRange: null,
    selectedDateValue: '',
    isCustomRange: false,
    clicked: false
  },
  newUnsoldTicketsFilter: {
    leagueId: [],
    ticketStatus: [],
    isFilter: false,
    startdate: null,
    enddate: null,
    startDateRange: null,
    endDateRange: null,
    selectedDateValue: '',
    isCustomRange: false,
    clicked: false
  },
  soldTicketFilter: {
    leagueId: null,
    leagueName: '',
    isFilter: false,
    paymentStatus: null,
    startdate: null,
    enddate: null,
    startDateRange: null,
    endDateRange: null,
    selectedDateValue: '',
    isCustomRange: false,
    notificationFilterDataCount:0,
    errorFilterDataCount:0,
    clicked: false,
    payoutType: null
  },
  unsoldTicketFilter: {
    leagueId: null,
    leagueName: '',
    isFilter: false,
    ticketStatus: null,
    startdate: null,
    enddate: null,
    startDateRange: null,
    endDateRange: null,
    selectedDateValue: '',
    isCustomRange: false,
    notificationFilterDataCount:0,
    errorFilterDataCount:0,
    clicked: false
  },
  delistAndReturnTicketFilter: {
    leagueId: null,
    leagueName: '',
    isFilter: false,
    ticketStatus: null,
    startdate: null,
    enddate: null,
    startDateRange: null,
    endDateRange: null,
    selectedDateValue: '',
    isCustomRange: false,
    notificationFilterDataCount:0,
    errorFilterDataCount:0,
    clicked: false
  },
  affiliateFilter:{
    typeName: null,
    status: null
  },
  affiliateTransactionFilter:{
    typeName: null,
    status: null
  },
  publishBulkticket:{
    publishBulk :false
  },
  markAsSoldTicket:{
    markAsSold : false,
    manangeTicketCalled:false
  },
  loadingFormarkassold:{
    soldloader : false
  },
  loadingForAutoPayout:{
    AutoPayoutLoader : false
  },
  loadingForVoidedPayout: {
    voidedPayoutLoader: false
  },
  payoutTicket:{
    payment: false
  },  
  affiliateAdded: {
    added: false
  },
  affiliateDelete : {
    deleted : false
  },
  affiliateUpdate : {
    updated: false
  },
  afterCreatedAffiliate: {
    referalLink: ""
  },
  affiliateNumberOfUsers : {
    numberOfUsers: null
  },
  usersPageLoader: {
    updateLoader: false
  },
  getallConfiguration:{
    updated : false
  },
  notificationCount:{
    past : 0,
    recent : 0
  },
  /** Support tickets with unread Victory Live replies (sidebar badge). */
  vlSupportUnread: 0,
  soldTickets:{
    failed : false,
    emailId : "",
    errorcount: 0
  },
  faq:{
    inserted : false
  },
  errorStatus:{
    addTicket : "Failed",
    publishTicket : "Failed",
    soldTicket :"Failed",
    stripePayout:"Failed"
  },
  trigger:{
    addTicketError:false,
    publishTicketError:false,
    soldTicketError:false
  },
  eventUpdate:{
    updateEvent : false
  }
};

export const globalContext = createContext({
  globalState: initialState,
  handleGlobalState: (obj: any) => {
    return obj;
  },
});

const AppProvider = ({ children }: PropsWithChildren<{}>) => {
  const [globalState, setGlobalState] = useState(initialState);
  const handleGlobalState = (obj: any) => {
    if (typeof obj === 'function') {
      setGlobalState(obj);
      return;
    }
    setGlobalState(obj);
  };
  return (
    <globalContext.Provider value={{ globalState, handleGlobalState }}>
      {children}
    </globalContext.Provider>
  );
};

export default AppProvider;
